import { Component, inject } from "@angular/core";
import { MatButton } from "@angular/material/button";
import { KeycloakAuthService } from "@lib/auth/services/keycloak-auth.service";

@Component({
    selector: "app-not-authorized-app-access",
    imports: [
        MatButton,
    ],
    templateUrl: "./not-authorized-app-access.component.html",
    styleUrl: "./not-authorized-app-access.component.scss",
})
export default class NotAuthorizedAppAccessComponent {
    private readonly authService = inject(KeycloakAuthService);

    logout() {
        this.authService.logOut();
    }
}
